import { 
    Box, Typography, Paper, Table, TableBody, TableCell, 
    TableContainer, TableHead, TableRow, Button, Chip, 
    useTheme, useMediaQuery 
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "../../Redux/Screen/Action";
import PaymentApi from "Service/Payment.api";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { StyledTableCell } from "./ProfessionalUserList";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const RewardRedeemRequests = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [requests, setRequests] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        fetchPendingRequests();
    }, []);

    const fetchPendingRequests = async () => {
        dispatch(startLoading({ loading: true, loadtext: "Fetching requests..." }));
        try {
            const response = await PaymentApi.getAllRedeemRequests();
            if (response.success) setRequests(response?.data.data || []);
        } catch (error) {
            console.error("Fetch error:", error);
        } finally {
            dispatch(stopLoading());
        }
    };

    const handleAction = async (requestId: number, action: 'Approve' | 'Reject') => {
        dispatch(startLoading({ loading: true, loadtext: `${action}ing request...` }));
        try {
            const response = await PaymentApi.verifyRedemption(requestId);
            if (response.success) {
                fetchPendingRequests();
            }
        } catch (error) {
            console.error("Action error:", error);
        } finally {
            dispatch(stopLoading());
        }
    };

    return (
        <Box p={isMobile ? 1 : 3}>
            {/* back button */}
           {/* 3. ADDED BACK BUTTON HERE */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Button 
                    startIcon={<ArrowBackIcon />} 
                    onClick={() => navigate(-1)}
                    sx={{ fontWeight: 'bold' }}
                >
                    Back
                </Button>
            </Box>
            <Typography variant={isMobile ? "h6" : "h5"} fontWeight="bold" mb={3}>
                Redemption Approval
            </Typography>

            <TableContainer 
                component={Paper} 
                sx={{ 
                    borderRadius: 3, 
                    boxShadow: 3,
                    // Makes table scrollable on small screens
                    maxWidth: '100%',
                    overflowX: 'auto' 
                }}
            >
                <Table sx={{ minWidth: 650 }}> {/* Ensures table doesn't squish too much */}
                    <TableHead sx={{ bgcolor: "#f5f5f5" }}>
                        <TableRow>
                            <StyledTableCell>User ID</StyledTableCell>
                            <StyledTableCell>User Name</StyledTableCell>
                            <StyledTableCell>Requested Points</StyledTableCell>
                            <StyledTableCell>Request Date</StyledTableCell>
                            <StyledTableCell>Status</StyledTableCell>
                            <StyledTableCell align="center">Actions</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {requests?.length ? (
                            requests?.map((req: any) => (
                                <TableRow key={req.id} hover>
                                    <TableCell>{req.clientId}</TableCell>
                                    <TableCell>{req.userName}</TableCell>
                                    <TableCell sx={{ fontStyle: "italic" }} >{req.pointsRequested}</TableCell>
                                    <TableCell>{req.date}</TableCell>
                                    <TableCell>
                                        <Chip 
                                            label={req.status} 
                                            color={req.status === "Approved" ? "success" : req.status === "Pending" ? "warning" : "error"} 
                                            size="small" 
                                        />
                                    </TableCell>
                                    <TableCell align="center">
                                        {/* Conditional Rendering: Only show buttons if Status is Pending */}
                                        {req.status === "Pending" ? (
                                            <Box display="flex" gap={1} justifyContent="center">
                                                <Button 
                                                    variant="contained" 
                                                    color="success" 
                                                    size="small"
                                                    startIcon={<CheckCircleIcon />}
                                                    onClick={() => handleAction(req.id, 'Approve')}
                                                >
                                                    Accept
                                                </Button>
                                                <Button 
                                                    variant="outlined" 
                                                    color="error" 
                                                    size="small"
                                                    startIcon={<CancelIcon />}
                                                    onClick={() => handleAction(req.id, 'Reject')}
                                                >
                                                    Reject
                                                </Button>
                                            </Box>
                                        ) : (
                                            <Typography variant="caption" color="text.primary">
                                                Processed
                                            </Typography>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
                                    No requests found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default RewardRedeemRequests;
